<template>
  <v-textarea
    v-model="$data[opts.key]"
    :name="opts.key"
    :label="label"
    :suffix="opts.suffix || null"
    :placeholder="
      opts.placeholder || $t('globals.fillField') + ' ' + label
    "
    :error-messages="errorMessages"
    @input="handleInput"
    @blur="$v[opts.key].$touch()"
  >
    <template
      v-if="description"
      #append
    >
      <v-tooltip top>
        <template #activator="{ on }">
          <v-icon v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        {{ description }}
      </v-tooltip>
    </template>
  </v-textarea>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  name: "TextArea",
  mixins: [validationMixin],
  props: {
    opts: {
      type: Object,
      default() {
        return {};
      },
    },
    config: {
      type: String,
      default() {
        return null;
      },
    },
  },
  data() {
    let data = {};
    let key = this.opts.key;
    data[key] = this.opts.value || null;
    return data;
  },
  computed: {
    label() {
      return (
          this.opts.name[this.$i18n.locale] +
          (this.opts.required != undefined && this.opts.required == true
              ? "*"
              : "")
      );
    },
    description() {
      return this.opts.description && this.opts.description[this.$i18n.locale];
    },
    errorMessages() {
      const errors = [];
      if (this.$v[this.opts.key] != undefined) {
        if (!this.$v[this.opts.key].$dirty) return errors;
        this.$v[this.opts.key].required !== undefined &&
        !this.$v[this.opts.key].required &&
        errors.push(this.$t("profile.reqField"));
        this.$v[this.opts.key].min !== undefined &&
        !this.$v[this.opts.key].min &&
        errors.push(
            this.$t("globals.minValue") +
            " " +
            this.$v[this.opts.key].$params.min.min
        );
        this.$v[this.opts.key].max !== undefined &&
        !this.$v[this.opts.key].max &&
        errors.push(
            this.$t("globals.maxValue") +
            " " +
            this.$v[this.opts.key].$params.max.max
        );
      }
      return errors;
    },
  },
  watch: {
    opts: {
      handler({ value, key }) {
        if (value && key) {
          this[key] = value;
        }
      },
      deep: true,
    },
    $data: {
      handler() {
        this.$emit("input", this.$data[this.opts.key]);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.config != null) this.$data[this.opts.key] = this.config;
  },
  methods: {
    handleInput() {
      this.$emit("input", this.$data[this.opts.key]);
    },
  },
  validations() {
    let validation = {};
    if (this.opts.validate != undefined && !_.isEmpty(this.opts.validate)) {
      let rules = {};
      this.opts.validate.forEach((item) => {
        switch (item) {
          case "required":
            rules[item] = required;
            break;
          default:
            if (item.includes("min:")) {
              rules.min = minLength(item.substring(4));
            }
            if (item.includes("max:")) {
              rules.max = maxLength(item.substring(4));
            }
            break;
        }
      });
      validation[this.opts.key] = rules;
    }
    return validation;
  },
};
</script>
